import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import style from "css/contact.module.css";
import Inputcontact from "./inputonsite";
import Postcode from "./postcode";
import axios from "axios";
import { openAlert } from "redux/slices/alertSlice";
import { useDispatch } from "react-redux";
import { useMediaQuery } from "react-responsive";

function Request() {
  const [info, setinfo] = useState({
    product: "ZWCAD",
    manager: "",
    phone: "",
    company: "",
    email: "",
    version1: "",
    version2: "",
    promotion1: false,
    promotion2: false,
    count: "",
    date: "",
  });

  const selectversion1 = [
    { value: "", name: "제품을 선택하세요" },
    { value: "ZWCAD", name: "ZWCAD" },
    { value: "ZW3D", name: "ZW3D" },
    { value: "ZDREAM", name: "ZDREAM" },
  ];
  const selectversion2 = [
    { value: "", name: "제품을 선택하세요" },
    { value: "Editor", name: "Foxit PDF Editor" },
    { value: "eSign", name: "Foxit eSign" },
    { value: "Reader", name: "PDF Reader" },
  ];
  const selectdate = [
    { value: "", name: "구입 예상 시기 선택" },
    { value: "1", name: "1개월 이내" },
    { value: "1to3", name: "1~3개월 이내" },
    { value: "3", name: "3개월 이상" },
    { value: "other", name: "기타" },
  ];

  const setccn = (e) => {
    e = e
      .replace(/[^0-9]/g, "")
      .replace(/^(\d{0,3})(\d{0,4})(\d{0,4})$/g, "$1-$2-$3")
      .replace(/(\-{1,2})$/g, "");
    setinfo({ ...info, phone: e });
  };
  const setcount = (e) => {
    e = e.replace(/[^0-9]/g, "");
    setinfo({ ...info, count: e });
  };
  const dispatch = useDispatch();

  const request = () => {
    if (check()) {
      axios
        .post("/open/request", info)
        .then((res) => {
          if (res.status === 200) {
            dispatch(
              openAlert({
                title: "Notice",
                content: "견적 요청이 완료되었습니다.",
                submitEventHandler: () =>
                  setinfo({
                    product: "ZWCAD",
                    manager: "",
                    phone: "",
                    company: "",
                    email: "",
                    version1: "",
                    version2: "",
                    promotion1: false,
                    promotion2: false,
                    count: "",
                    date: "",
                  }),
              })
            );
          }
        })
        .catch((err) => {
          dispatch(
            openAlert({
              title: "Notice",
              content: err.response.data,
            })
          );
        });
    }
  };

  const check = () => {
    if (info.manager === "") {
      dispatch(
        openAlert({
          title: "Notice",
          content: "신청자를 입력해주세요",
          submitEventHandler: () => {},
        })
      );
      return false;
    } else if (info.phone === "") {
      dispatch(
        openAlert({
          title: "Notice",
          content: "연락처를 입력주세요",
          submitEventHandler: () => {},
        })
      );
      return false;
    } else if (info.company === "") {
      dispatch(
        openAlert({
          title: "Notice",
          content: "회사명을 입력해주세요",
          submitEventHandler: () => {},
        })
      );
      return false;
    } else if (info.version1 === "" && info.version2 === "") {
      dispatch(
        openAlert({
          title: "Notice",
          content: "제품을 선택해주세요",
          submitEventHandler: () => {},
        })
      );
      return false;
    } else {
      return true;
    }
  };
  const clicktab = (value) => {
    if (!(value === info.product)) {
      setinfo({
        ...info,
        product: value,
        version1: "",
        version2: "",
        promotion1: false,
        promotion2: false,
      });
    }
  };
  const checkline = useMediaQuery({
    query: "(min-width: 1301px)",
  });
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });

  return (
    <>
      <div className={style.wrapper_h}>
        <div
          className={style.background}
          style={{
            backgroundImage:
              "url('" +
              process.env.REACT_APP_CLIENT_URL +
              "img/contact/request_bg.png')",
          }}
        >
          <div className={style.background_blur}></div>
        </div>
        <div className={style.contact_area}>
          <div className={style.contact_title_wrap}>
            <div className={style.contact_title}>견적요청</div>
            <div className={style.contact_subtitle}>Request for estimate</div>
          </div>
        </div>
      </div>
      <div className={style.contact_wrapper}>
        <div className={style.contact_body}>
          <div className={style.contact_contents}>
            <div className={style.contact_contents_title}>
              <p>
                <font className={style.contact_mobile_font}>
                  ZWCAD, ZW3D, {isMobile ? <br /> : ""} Foxit PDF 등
                </font>
              </p>
              <p className={style.contact_mobile_font}>
                {" "}
                블루티엔에스에서 {isMobile ? <br /> : ""}공급하는 제품에 대한{" "}
                {isMobile ? <br /> : ""}
                정확한 견적이 필요하신 경우,
              </p>
              <p className={style.contact_mobile_font}>
                {" "}
                아래 견적 신청서를 통해 {isMobile ? <br /> : ""} 문의해 주시기
                바랍니다.
              </p>
            </div>
            <div className={style.contact_contents_title2}>
              <p>
                고객님께서 작성해 주신 내용을 바탕으로,{isMobile ? <br /> : ""}
                <font> 전문 담당자가 확인 후 1영업일 이내에</font>
                {isMobile ? <br /> : ""}
              </p>
              <p>
                맞춤형 견적서와 제품 안내 자료를{isMobile ? <br /> : ""} 신속히
                전달드리겠습니다.
              </p>
            </div>
            <div className={style.contact_contents_info}>
              <div className={style.contact_contents_box_2}>
                <div className={style.contact_contents_box_title}>
                  <font>01</font> 제공 제품
                </div>
                <div className={style.contact_contents_box_body2}>
                  <div className={style.contact_contents_box_body_info}>
                    {isMobile ? (
                      ""
                    ) : (
                      <div
                        className={style.contact_contents_box_body_info_dot}
                      />
                    )}
                    <div className={style.contact_contents_box_body_info_title}>
                      {isMobile ? (
                        <div
                          className={style.contact_contents_box_body_info_dot}
                        />
                      ) : (
                        ""
                      )}{" "}
                      ZWCAD
                    </div>
                    <div className={style.contact_contents_box_body_info_txt}>
                      : 범용 CAD 설계 솔루션
                    </div>
                  </div>
                  <div className={style.contact_contents_box_body_info}>
                    {isMobile ? (
                      ""
                    ) : (
                      <div
                        className={style.contact_contents_box_body_info_dot}
                      />
                    )}
                    <div className={style.contact_contents_box_body_info_title}>
                      {isMobile ? (
                        <div
                          className={style.contact_contents_box_body_info_dot}
                        />
                      ) : (
                        ""
                      )}{" "}
                      ZW3D
                    </div>
                    <div className={style.contact_contents_box_body_info_txt}>
                      : 3D CAD/CAM 통합 솔루션
                    </div>
                  </div>
                  <div className={style.contact_contents_box_body_info}>
                    {isMobile ? (
                      ""
                    ) : (
                      <div
                        className={style.contact_contents_box_body_info_dot}
                      />
                    )}
                    <div className={style.contact_contents_box_body_info_title}>
                      {isMobile ? (
                        <div
                          className={style.contact_contents_box_body_info_dot}
                        />
                      ) : (
                        ""
                      )}
                      Foxit PDF Editor
                    </div>
                    <div className={style.contact_contents_box_body_info_txt}>
                      : 기업용 PDF 편집 솔루션
                    </div>
                  </div>
                  <div className={style.contact_contents_box_body_info}>
                    {isMobile ? (
                      ""
                    ) : (
                      <div
                        className={style.contact_contents_box_body_info_dot}
                      />
                    )}
                    <div className={style.contact_contents_box_body_info_title}>
                      {isMobile ? (
                        <div
                          className={style.contact_contents_box_body_info_dot}
                        />
                      ) : (
                        ""
                      )}{" "}
                      기타
                    </div>
                    <div className={style.contact_contents_box_body_info_txt}>
                      : Microsoft Office, 한글과컴퓨터, Adobe 등 주요 상용
                      소프트웨어
                    </div>
                  </div>
                </div>
              </div>
              <div className={style.contact_contents_box_2}>
                <div className={style.contact_contents_box_title}>
                  <font>02</font> 견적 신청 절차
                </div>
                <div className={style.contact_contents_box_content3}>
                  <div className={style.request_stepWrap}>
                    <div className={style.request_step}>
                      <div className={style.request_step_num}>1</div>
                      <div className={style.request_step_txt}>
                        <p>신청서 작성</p>
                        <p>(아래 버튼 클릭)</p>
                      </div>
                      <div className={style.request_step_line} />
                    </div>
                    <div className={style.request_step}>
                      <div className={style.request_step_num}>2</div>
                      <div className={style.request_step_txt}>
                        <p>전문 담당자 확인 및</p>
                        <p> 추가 상담</p>
                      </div>
                      <div className={style.request_step_line} />
                    </div>{" "}
                    <div className={style.request_step}>
                      <div className={style.request_step_num}>3</div>
                      <div className={style.request_step_txt}>
                        <p>맞춤 견적서 및</p>
                        <p> 제품 자료 발송</p>
                      </div>
                      <div className={style.request_step_line} />
                    </div>{" "}
                    <div className={style.request_step}>
                      <div className={style.request_step_num}>4</div>
                      <div className={style.request_step_txt}>
                        <p>계약 및 </p>
                        <p>설치/기술지원 안내</p>
                      </div>
                      <div></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={style.contact_form}>
          <div className={style.contact_form_header}>견적 신청</div>
          <div className={style.contact_form_body}>
            {isMobile ? (
              <div className={style.contact_form_body_wrap}>
                <div className={style.contact_form_body_img}>
                  <img
                    alt=""
                    src={
                      process.env.REACT_APP_CLIENT_URL +
                      "img/support/qrrequest_m.png"
                    }
                  />
                  <div>
                    <p>모바일에서도 </p>
                    <p> 바로 접속하려면 </p>
                    <p> 좌측 QR 코드를 스캔하세요.</p>
                  </div>
                </div>
                <div
                  className={style.contact_form_body_txt}
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    window.open(
                      "https://form.typeform.com/to/CbKYNlsU?typeform-source=qrcode-button",
                      "_blank"
                    )
                  }
                >
                  견적 신청서 작성하기
                </div>
              </div>
            ) : (
              <div className={style.contact_form_body_wrap}>
                <div>
                  <img
                    alt=""
                    src={
                      process.env.REACT_APP_CLIENT_URL +
                      "img/support/qrrequest.png"
                    }
                  />
                </div>
                <div className={style.contact_form_body_txt}>
                  <div>
                    모바일에서도 바로 접속하려면 좌측 QR 코드를 스캔하세요.
                  </div>
                  <div
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      window.open(
                        "https://form.typeform.com/to/CbKYNlsU?typeform-source=qrcode-button",
                        "_blank"
                      )
                    }
                  >
                    견적 신청서 작성하기
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className={style.contact_form_footer}>
            ※ 본 서비스는 기업 고객을 위한 전용 견적 서비스입니다. 개인 고객의
            경우, 신청서 작성 후 별도 상담을 통해 안내해 드립니다.{" "}
            {isMobile ? "" : <br />}
            제출하신 정보는 제품 상담 이외의 용도로 사용되지 않습니다.
          </div>
        </div>
      </div>
    </>
  );
}

export default Request;
